import { render, staticRenderFns } from "./SideMenuWithCategories.vue?vue&type=template&id=c461efea"
import script from "./SideMenuWithCategories.vue?vue&type=script&lang=js"
export * from "./SideMenuWithCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports